import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "min-w-0"
};
const _hoisted_2 = {
  class: "min-w-0"
};
const _hoisted_3 = {
  class: "truncate text-sm font-medium text-slate-900"
};
const _hoisted_4 = {
  class: "mt-0.5 truncate text-xs text-slate-500"
};
const _hoisted_5 = {
  class: "mt-4 min-w-0"
};
const _hoisted_6 = {
  class: "flex min-w-0 items-baseline gap-1"
};
const _hoisted_7 = {
  key: 0,
  class: "shrink-0 text-xs font-medium text-slate-500"
};
const _hoisted_8 = {
  class: "mt-3 flex min-w-0 items-center justify-between gap-2"
};
const _hoisted_9 = {
  class: "truncate text-xs text-slate-500"
};
import { computed } from 'vue';
export default {
  __name: 'StatisticMetricCard',
  props: {
    metric: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    const trendClass = computed(() => {
      if (props.metric.error) return 'status-badge is-rose';
      // 中文金融惯例:红涨绿跌(仅涨跌数值语境)
      if (props.metric.trend === 'up') return 'status-badge is-danger';
      if (props.metric.trend === 'down') return 'status-badge is-success';
      return 'status-badge is-neutral';
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["min-w-0 rounded-xl border border-slate-200/70 bg-white p-4 shadow-sm transition-colors duration-200 hover:border-slate-300", {
          'border-rose-200 bg-rose-50/30': __props.metric.error
        }])
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("p", _hoisted_3, _toDisplayString(__props.metric.title), 1), _createElementVNode("p", _hoisted_4, _toDisplayString(__props.metric.caption), 1)])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("span", {
        class: _normalizeClass(["min-w-0 truncate text-2xl font-semibold leading-8 text-slate-950", {
          'text-slate-400': __props.metric.loading || __props.metric.error
        }])
      }, _toDisplayString(__props.metric.value), 3), __props.metric.valueLabel ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(__props.metric.valueLabel), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("span", _hoisted_9, _toDisplayString(__props.metric.subText), 1), _createElementVNode("span", {
        class: _normalizeClass(["shrink-0 rounded-full px-2 py-0.5 text-xs font-medium", trendClass.value])
      }, _toDisplayString(__props.metric.growthText), 3)])])], 2);
    };
  }
};